import React from 'react'
import { useMatch } from 'react-router-dom';
import routePathSegments, { routeNames } from '../../routeSegments'
import NavbarItems from './NavbarItems'
import NavbarWrapper from './NavbarWrapper'

/**
 * The `Header` component renders a navigation bar with different links based
 * on the current route.
 * @returns a JSX element, specifically a NavbarWrapper component with several NavbarItems components
 * inside.
 */
function Header() {
    const isFaqMatch = useMatch({ path: `/${routePathSegments.faq}/*` })
    
    return (
        <NavbarWrapper />
    )
}

export default Header